import { Icon } from './Icon';

export type Route =
  | 'dashboard'
  | 'queue'
  | 'trigger'
  | 'runs'
  | 'ledger'
  | 'legacy'           // legacy (grandfathered) clients per territory — admins + reviewers
  | 'ziplookup'        // clients served in one zip, last 90 days — admins + reviewers
  | 'notices'          // notification audit log
  | 'case'             // full-page case detail (?case=N deep-link)
  | 'admin-users'
  | 'admin-system'
  | 'admin-config';

interface SidebarProps {
  active: Route;
  onNav: (r: Route) => void;
  queueCount: number;
  role: 'admin' | 'reviewer';
}

export function Sidebar({ active, onNav, queueCount, role }: SidebarProps) {
  const item = (id: Route, label: string, icon: Parameters<typeof Icon>[0]['name'], count?: number) => (
    <div className={`nav-item${active === id ? ' active' : ''}`} onClick={() => onNav(id)}>
      <Icon name={icon} size={16} color={active === id ? 'var(--header-fg)' : 'var(--header-fg-faint)'} />
      <span>{label}</span>
      {count != null && <span className="nav-count">{count}</span>}
    </div>
  );

  return (
    <nav style={{
      width: 220,
      background: 'var(--header-bg)',
      color: 'var(--header-fg-faint)',
      flexShrink: 0,
      padding: '8px 8px 16px',
      display: 'flex', flexDirection: 'column',
      borderRight: '1px solid rgba(0,0,0,0.2)',
    }}>
      <div className="nav-section">Operate</div>
      {item('dashboard', 'Dashboard', 'home')}
      {item('queue', 'Case queue', 'inbox', queueCount)}
      {item('trigger', 'Trigger audit', 'play')}
      {item('runs', 'Audit runs', 'history')}
      {item('ledger', 'Exception ledger', 'shield')}
      {item('legacy', 'Legacy clients', 'clock')}
      {item('ziplookup', 'Zip code lookup', 'location')}
      {item('notices', 'Notices sent', 'bell')}

      {role === 'admin' && (
        <>
          <div className="nav-section">Admin</div>
          {item('admin-users', 'Users & roles', 'users')}
          {item('admin-system', 'System health', 'server')}
          {item('admin-config', 'Config', 'sliders')}
        </>
      )}

      <div style={{ flex: 1 }} />
      <div style={{ padding: '8px 10px', fontSize: 11, color: 'var(--header-fg-faint)', display: 'flex', alignItems: 'center', gap: 8, borderTop: '1px solid rgba(255,255,255,0.06)', marginTop: 8 }}>
        <Icon name="pulse" size={13} color="oklch(0.7 0.15 160)" />
        <span>All systems normal</span>
      </div>
    </nav>
  );
}
